module.exports = __webpack_public_path__ + "static/keyflow2-d00fdfff7f6248d90934958d7b8ee223.png";